module.exports = __webpack_public_path__ + "static/img/1-3.82a318b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/1-3.jpg
// module id = DDE7
// module chunks = 1